<template>
  <div v-loading="fetchingUsers">
    <!-- large screen -->
    <div class="d-none d-md-block" id="table-wrapper ">
      <table class="custom-table responsive-table border-collapse">
        <thead>
          <tr class="shadow-md rounded-lg">
            <th class="checkbox">
              <base-checkbox v-model="selectAll" />
            </th>
            <th>Name</th>
            <th>Email</th>
            <!-- <th>Function</th> -->
            <th>Reason for Deactivation</th>
            <th>Date Deactivated</th>
            <th class="relative actions" tabindex="-1">
              <span class="cursor-pointer">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g opacity="0.7">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M4 0.130371C5.86384 0.130371 7.42994 1.46057 7.87398 3.26081H16V5.34776H7.87398C7.42994 7.148 5.86384 8.4782 4 8.4782C1.79086 8.4782 0 6.60947 0 4.30428C0 1.9991 1.79086 0.130371 4 0.130371ZM4 6.39124C5.10457 6.39124 6 5.45688 6 4.30428C6 3.15169 5.10457 2.21733 4 2.21733C2.89543 2.21733 2 3.15169 2 4.30428C2 5.45688 2.89543 6.39124 4 6.39124Z"
                      fill="#383F51" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M14 17.8695C12.1362 17.8695 10.5701 16.5393 10.126 14.7391H2V12.6521H10.126C10.5701 10.8519 12.1362 9.52168 14 9.52168C16.2091 9.52168 18 11.3904 18 13.6956C18 16.0008 16.2091 17.8695 14 17.8695ZM14 15.7825C15.1046 15.7825 16 14.8482 16 13.6956C16 12.543 15.1046 11.6086 14 11.6086C12.8954 11.6086 12 12.543 12 13.6956C12 14.8482 12.8954 15.7825 14 15.7825Z"
                      fill="#383F51" />
                  </g>
                </svg></span>
            </th>
          </tr>
        </thead>
        <tbody v-if="!fetchingUsers && filteredUsers.length == 0">
          <tr>
            <td colspan="6">
              <empty-table-icon />
              <p class="text-center pt-3 pb-5">No Deactivated Users found!</p>
            </td>
          </tr>
          <tr v-if="fetchingUsers">
            <td></td>
            <td></td>
            <td>
              <loader />
            </td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr v-for="user in filteredUsers" :key="user.id" class="shadow-md rounded-lg">
            <td>
              <base-checkbox v-model="selectedUserIds" :value="user.id" />
            </td>
            <td>
              {{ user.firstname }} {{ user.lastname }}
            </td>
            <td>{{ user.email }}</td>
            <!-- <td>
              {{ user.function }}
            </td> -->
            <td>{{ user.deactivationReason }}</td>
            <td>{{ user.updatedAt | formatDate }}</td>
            <td class="table__action-btn cursor-pointer" tabindex="-1" @blur="selectedRowId = null">
              <span @click="showActionOptions(user.id)">
                <vertical-ellipsis />
              </span>
              <div class="table__action-options" v-if="selectedRowId == user.id">
                <div class="table__action-option cursor-pointer" @click="reactivateUser(user.id)">
                  <p>Reactivate</p>
                </div>
                <div class="table__action-option cursor-pointer" @click="showDeleteModal(user)">
                  <p>Delete User</p>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- mobile screen -->
    <div class="d-md-none">
      <div v-for="(user, i ) in filteredUsers" :key="i" class="custom-card flex justify-between my-3 text-xs">
        <div class="col-11">
          <!-- {{user}} -->
        <div class="flex row flex-row justify-between grow">
          <div class="my-3 col-7">
            <div class="flex">
              <div><img src="@/assets/images/icons/cancel.svg" class="align-top" alt="" /></div>
              <span class="my-auto text-muted ml-2"
                >Name <br />
                <span class="font-semibold">{{ user.fname }} 
                  {{ user.lname }}</span>
              </span>
            </div>
          </div>
          <div class="my-3 col col-span-2">
            <div class="flex">
              <div><img src="@/assets/images/icons/cancel.svg" class="align-top" alt="" /></div>
              <span class="my-auto text-muted ml-2"
                >Function <br />
                <span class="font-semibold">{{ user.orgFunction ? user.orgFunction.name : "Nill" }}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="flex row flex-row justify-between grow">
          <div class="my-3 col-7">
            <div class="flex">
              <div>
                <img src="@/assets/images/icons/cancel.svg" class="align-top" alt="" />
              </div>
              <span class="my-auto text-muted ml-2"
                >Email <br />
                <span class="font-semibold">{{user.email}}</span>
              </span>
            </div>
          </div>
        </div>
        <div class="flex row flex-row justify-between grow">
          <div class="my-3 col-7">
            <div class="flex">
              <div><img src="@/assets/images/icons/cancel.svg" class="align-top" alt="" /></div>
              <span class="my-auto text-muted ml-2"
                >Reason <br />
                <span class="font-semibold">{{ user.deactivationReason }}</span>
              </span>
            </div>
          </div>
          <div class="my-3 col">
            <div class="flex">
              <div><img src="@/assets/images/icons/cancel.svg" class="align-top" alt="" /></div>
              <span class="my-auto text-muted ml-2"
                >Date Deactivated <br />
                <span class="font-semibold">{{ user.updatedAt | formatDate }}</span>
              </span>
            </div>
          </div>
        </div>
        </div>
        <div class="flex-none">
          <span @click="showActionOptions(user.id)">
                <vertical-ellipsis />
              </span>
              <div class="table__action-options" v-if="selectedRowId == user.id">
                <div class="table__action-option cursor-pointer" @click="reactivateUser(user.id)">
                  <p>Reactivate</p>
                </div>
                <div class="table__action-option cursor-pointer" @click="showDeleteModal(user)">
                  <p>Delete User</p>
                </div>
              </div>
        </div>
      </div>
    </div>
    <pagination-control />
    <delete-user-modal ref="deleteUserModal" @user-deleted="onUserDeleted" />
  </div>
</template>
<script>
import PaginationControl from "@/components/UI/NewPagination";
import DeleteUserModal from "./Modals/DeleteUserModal.vue";
export default {
  components: {
    PaginationControl,
    DeleteUserModal
  },
  props: ["deactivatedUsers", "fetchingUsers"],
  data() {
    return {
      selectedRowId: null,
      selectedOption: "functional",
      options: [
        { value: "functional", text: "Functional" },
        { value: "management", text: "Management" },
        { value: "projects", text: "Projects" },
      ],
      selectedUserIds: [],
      selectAll: false,
      queryString: "",
      sortList: false,
    };
  },
  computed: {
    filteredUsers() {
      let groups = this.filterArray(this.deactivatedUsers, this.queryString);
      // return this.groups;
      return this.sortList
        ? groups.sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        })
        : groups;
    },
    UGQueryString() {
      return this.$store.getters.getUserAndGroupsQuery;
    },
    UGQuerySortList() {
      return this.$store.getters.userAndGroupSortList;
    },
  },
  watch: {
    selectAll() {
      if (this.selectAll) {
        this.selectedUserIds = [];
        this.filteredUsers.forEach((user) => {
          this.selectedUserIds.push(user.id);
        });
      } else {
        this.selectedUserIds = [];
      }
    },
    UGQueryString(value) {
      this.queryString = value;
    },
    UGQuerySortList(value) {
      this.sortList = value;
    },
  },
  methods: {
    async reactivateUser(userId) {
      this.generateToast("Reactivating user...", "success");
      try {
        let response = await this.$_reactivateUser(userId, { deactivationReason: "reactivate" });
        console.log(response);
        this.generateToast("User Reactivated!", "success");
        this.updateUsers();
      } catch (error) {
        this.handleError(error);
      }
    },
    async deleteMultipleUsers() {
      let payload = this.createPayload();
      this.generateToast("Deleting Users...", "success");
      try {
        let response = await this.$_deleteMultipleUsers(payload);
        console.log(response);
        this.generateToast("Users have been deleted!", "success");
        this.updateUsers();
      } catch (error) {
        this.handleError(error);
      }
    },
    async reactivateMultipleUsers() {
      let payload = this.createPayload();
      this.generateToast("Reactivating Users...!", "success");
      try {
        let response = await this.$_reactivateMultipleUsers(payload);
        console.log(response);
        this.generateToast("Users have been reactivated!", "success");
        this.selectAll = false;
        this.updateUsers();
      } catch (error) {
        this.handleError(error);
      }
    },
    createPayload() {
      // converts array of user ID's into the objet=ct format expected by the endpoint
      let payload = [];
      console.log(this.selectedUserIds, " u get ti");
      this.selectedUserIds.forEach((id) => {
        let userIdObject = {};
        userIdObject.groupuserId = id;
        payload.push(userIdObject);
      });
      return payload;
    },
    updateUsers() {
      this.$emit("update-deactivated-users");
      // Resets stored users from session storage so users can be updated
      this.$store.dispatch("resetUserList");
    },
    showActionOptions(id) {
      if (!this.selectedRowId) {
        this.selectedRowId = id;
      } else {
        this.selectedRowId = null;
      }
    },
    showDeleteModal(user) {
      this.$refs.deleteUserModal.showModal(user);
      // this.resetSelectedRow();
    },
    onUserDeleted(){
      this.$emit("refetch-users");
    },
    showViewRoleModal() {
      this.$emit("show-view-role-modal");
      this.resetSelectedRow();
    },
    resetSelectedRow() {
      this.selectedRowId = null;
    },
  },
};
</script>
